import { useState, useEffect } from 'react';
import { getPendingPayoutTimesheetsCount } from '../services/api/timekeeping';
import { BRAND_COLORS } from '../config';

/**
 * Custom hook to manage pending payout timesheets data
 * @param {Object} contextUser - The current user context
 * @returns {Object} Object containing count and color for pending payout timesheets
 */
export const usePayoutTimesheets = (contextUser) => {
  const [pendingPayoutSheets, setPendingPayoutSheets] = useState({
    count: 0,
    color: BRAND_COLORS.status.error,
  });

  useEffect(() => {
    // Only fetch if user has appropriate roles
    if (
      contextUser &&
      (contextUser.manager || contextUser.executive || contextUser.staff)
    ) {
      const fetchPendingPayoutSheets = async () => {
        try {
          const result = await getPendingPayoutTimesheetsCount();
          setPendingPayoutSheets({
            count: result.count || 0,
            color:
              result.count > 0
                ? BRAND_COLORS.status.error
                : BRAND_COLORS.status.success,
          });
        } catch (error) {
          console.error("Error fetching pending payout timesheets:", error);
          setPendingPayoutSheets({ 
            count: 0, 
            color: BRAND_COLORS.status.success 
          });
        }
      };

      fetchPendingPayoutSheets();
    }
  }, [contextUser]);

  return pendingPayoutSheets;
};
